document.addEventListener("DOMContentLoaded", function () {
  const mobileInput = document.getElementById("Cart-mobile");
  const checkoutButton = document.getElementById("checkout");
  const errorText = document.getElementById("mobile-error");

  checkoutButton.addEventListener("click", function (event) {
    const mobileValue = mobileInput.value.trim();

    if (!(/^\d{10}$/.test(mobileValue))) {
      event.preventDefault(); // Stop checkout
      alert("❌ Invalid mobile number. Please enter a 10-digit number.");
    }
  });
});
